// Modules
import browserStorage from 'store';
import store from 'app-store';

// Action types
import { LOAD, LOGOUT, INITIALIZE, UPDATE_CURRENT_USER } from './action-types';


// Action creators
export function logout() {
  browserStorage.remove('auth');

  store.dispatch({
    type: LOGOUT
  });
}

export function load(token, profile) {
  browserStorage.set('auth', { token, profile });

  store.dispatch({
    type: LOAD,
    token,
    profile
  });
}

export function initialize(lock) {
  store.dispatch({
    type: INITIALIZE,
    lock
  });
}

export function updateCurrentUser(currentUser) {
  store.dispatch({
    type: UPDATE_CURRENT_USER,
    currentUser
  });
}



// WEBPACK FOOTER //
// ./app/modules/auth/actions.js